// extracted by mini-css-extract-plugin
export default {"container":"mO-z","topReviewHeading":"nO-z","criticalReview":"oO-z","favorableReview":"pO-z","vsSeparator":"qO-z"};